import { config } from '_/config/config'

import { customRoutes } from '~/router/router'

import { testingRoutes } from '_/router/testingRoutes'

import Vue from 'vue'

import VueRouter from 'vue-router'

import Echo from 'laravel-echo'

import _ from 'lodash'

import Pusher from 'pusher-js'

const photonConfig = require('~/config/config.json')

import { pLog, pWarn } from '_/helpers/logger'

import { store } from '_/vuex/store'

import { storage } from '_/services/storage'

import {
  Admin,
  ConfirmReset,
  Dashboard,
  EmailConfirmation,
  EmailChangeConfirmation,
  ErrorPage,
  ForgotPassword,
  Generator,
  InvalidLicense,
  ApiCallsExceeded,
  Login,
  MenuEditor,
  MenuItemsEditor,
  Notifications,
  PasswordReset,
  Register,
  Registered,
  SetNewPassword,
  SocialLogin,
} from '@/route-components'

Vue.use(VueRouter)

const routes = [
  ...testingRoutes,
  ...customRoutes,
  {
    path: '/',
    component: Dashboard,
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/login',
    component: Login,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/social-login',
    component: SocialLogin,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/register',
    component: Register,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/register/:invitationToken',
    component: Register,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/registered',
    component: Registered,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/confirm-email/:emailToken',
    component: EmailConfirmation,
  },
  {
    path: '/confirm-email-change/:emailToken/:userId',
    component: EmailChangeConfirmation,
    meta: {
      onlyIfAuthenticated: true,
    },
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/confirm-password-reset',
    component: ConfirmReset,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/reset-password/:emailToken',
    component: SetNewPassword,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/password-reset-success',
    component: PasswordReset,
    meta: {
      onlyIfNotAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/notifications',
    component: Notifications,
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '/generator',
    component: Generator,
    meta: {
      onlyIfAuthenticated: true,
      onlyDevEnv: true,
      sidebarWidthGroup: 'generator',
    },
  },
  {
    path: '/generator/:moduleTableName',
    component: Generator,
    meta: {
      onlyIfAuthenticated: true,
      onlyDevEnv: true,
      sidebarWidthGroup: 'generator',
    },
  },
  {
    path: '/menu-editor',
    component: MenuEditor,
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'menu-editor',
    },
  },
  {
    path: '/menu-editor/:menuId',
    component: MenuEditor,
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'menu-editor',
    },
  },
  {
    path: '/menu-items-editor',
    component: MenuItemsEditor,
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'menu-items-editor',
    },
  },
  {
    path: '/menu-items-editor/:menuId',
    component: MenuItemsEditor,
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'menu-items-editor',
    },
  },
  {
    path: '/menu-items-editor/:menuId/:menuItemId',
    component: MenuItemsEditor,
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'menu-items-editor',
    },
  },
  {
    path: '/admin/:moduleTableName',
    component: Admin,
    meta: {
      onlyIfAuthenticated: true,
      onlyDevEnv: true,
      sidebarWidthGroup: 'admin',
    },
  },
  {
    path: '/admin/:moduleTableName/:moduleEntryId',
    component: Admin,
    meta: {
      onlyIfAuthenticated: true,
      onlyDevEnv: true,
      sidebarWidthGroup: 'admin',
    },
  },
  {
    path: '/error/:errorName',
    component: ErrorPage,
    name: 'error',
  },
  {
    path: '/invalid-license/:errorType',
    component: InvalidLicense,
  },
  {
    path: '/api-calls-exceeded',
    component: ApiCallsExceeded,
  },
  {
    path: '/invalid-license',
    component: InvalidLicense,
  },
  {
    path: '/asset-manager/:assetId',
    component: Dashboard,
    name: 'asset-manager',
    meta: {
      onlyIfAuthenticated: true,
      sidebarWidthGroup: 'default',
    },
  },
  {
    path: '*',
    component: ErrorPage,
  },
]

export const router = new VueRouter({
  base: config.ENV.controlPanelBase,
  mode: 'history',
  routes,
})

const checkRouteAvailability = (to, from, next) => {
  if (store.state.user.loggedIn) {
    if (to.matched.some(record => record.meta.onlyIfNotAuthenticated)) {
      return next({
        path: '/',
      })
    }

    store.dispatch('notification/getUnreadNotifications')

    // Unsubscribe a user from entry subscriptions
    store.dispatch('subscription/unsubscribe', {
      entryId: from.params.moduleEntryId,
      moduleTableName: from.params.moduleTableName,
    })

    return next()
  }

  // Else if non-authenticated user
  if (to.matched.some(record => record.meta.onlyIfAuthenticated)) {
    return next({
      // Redirect to login
      path: '/login',
      query: { redirect: to.fullPath },
    })
  }

  next()
}

const runLaravelEcho = function(apiToken, userId) {
  if (process.env.MIX_ECHO_ENABLED == 'false') {
    return
  }

  if (_.has(window, 'Echo') && !_.isEmpty(window.Echo)) {
    return
  }

  window.io = require('socket.io-client')

  const Authorization = 'Bearer ' + apiToken

  window.Echo = new Echo({
    auth: {
      headers: { Authorization },
    },
    authEndpoint:
      config.ENV.apiBasePath.replace(new RegExp('api$'), '') +
      'broadcasting/auth',
    broadcaster: 'socket.io',
    host: window.location.hostname + ':6001',
  })

  window.Echo.private(
    `${process.env.MIX_APP_DOMAIN}-user-${userId}`
  ).notification(notification => {
    pWarn('New Echo notification received.', notification)

    store
      .dispatch('notification/addNotification', { notification })
      .then(() => {
        if (
          notification.type ===
          'Photon\\PhotonCms\\Core\\Entities\\Notifications\\CelebritiesTagged'
        ) {
          store.dispatch('assets/refreshAssetById', {
            assetId: notification.entry_id,
          })
        }

        store.dispatch('notification/getUnreadNotifications')
      })
  })
}

/**
 * Middleware to check auth before each route
 *
 * @return  {void}
 */
router.beforeEach((to, from, next) => {
  if (to.name === 'error') {
    checkRouteAvailability(to, from, next)
    return
  }

  handleLogin(to, from, next)
})

const handleLogin = function handleLogin(to, from, next) {
  pLog('Attepmting transition to path', to.fullPath)

  // Gets API token from storage if any
  const apiToken = storage.get('apiToken')

  // If there's a stored API token and user is not logged in check '/me' route to see if token is still valid
  if (!store.state.user.loggedIn && apiToken) {
    store.dispatch('user/checkMe', { apiToken }).then(() => {
      init(to, from, next, apiToken)
    })

    return
  }

  // If a user is logged in and has an apiToken stored
  if (store.state.user.loggedIn && apiToken) {
    init(to, from, next, apiToken)

    return
  }
  // Else if no token was stored
  checkRouteAvailability(to, from, next)
}

const init = function(to, from, next, apiToken) {
  if (to.name === 'error') {
    checkRouteAvailability(to, from, next)

    return
  }

  checkIfOnlyDevEnv(to, from, next)

  store.dispatch('ui/getLocales', {}).then(() => {
    Promise.all([
      store.dispatch('photonModule/getPhotonModules', {}),
      store.dispatch('photonField/getPhotonFields', {}),
    ]).then(() => {
      runLaravelEcho(apiToken, store.state.user.meta.id)

      checkRouteAvailability(to, from, next)
    })
  })
}

const checkIfOnlyDevEnv = function(to, from, next) {
  let forbbidenTables = photonConfig.onlyDevEnvAllowedTables

  if (to.meta.onlyDevEnv) {
    if (
      to.path.includes('generator') ||
      forbbidenTables.includes(to.params.moduleTableName)
    ) {
      if (!store.state.ui.isDevEnv) {
        return next({
          path: '/error/resource-not-found',
        })
      }
    }
  }
}
